export const FleetIsRoutes = {
  Dashboard: '/dashboard',
  ChargingStations: '/charging-stations',
  EditChargingStation: 'edit',
  ChargingStationDetailsConfigurationTab: '16/configuration',
  ChargingStationDetailsConfigurationTabEdit: 'edit',
  ChargingStationDetailsGeneralTab: '16/general',
  AddChargingStation: '/charging-stations/add',
  DeleteChargingStation: ':identityKey/delete',
  EditChargingStationFromTable: ':identityKey/edit',
  Tours: '/tours',
  CreateTour: '/create-tour',
  CreateChargingSchedule: '/create-charging-schedule',
  TourDetails: '/tours/:tourId',
  ChargingStationDetails: ':identityKey',
  ChargingSchedule: '/charging-schedule',
  Vehicles: '/vehicles',
  AddVehicle: '/vehicles/add',
  DeleteVehicle: '/vehicles/:vehicleId/delete',
  EditVehicle: '/vehicles/:vehicleId/edit',
  BusinessAccounts: '/business-accounts',
  BusinessAccountDetails: '/business-accounts/:businessAccountId',
};
